import { gql } from '@/lib/graphqlRequest';

export const createPresignedUploadUrls = gql`
  mutation createPresignedUploadUrls(
    $files: [UploadFileInput!]!
    $type: UploadType!
    $reference: UploadReference!
  ) {
    createPresignedUploadUrls(
      files: $files
      type: $type
      reference: $reference
    ) {
      id
      url
      fields
    }
  }
`;

export const createDownloadUrl = gql`
  mutation createDownloadUrl(
    $id: ObjectID!
    $type: DownloadType!
    $reference: DownloadReference!
  ) {
    createDownloadUrl(id: $id, type: $type, reference: $reference)
  }
`;
